import React from 'react';
import './Fourohfour.css';

const Fourohfour = () => {
  const music = [
    `How are trumpets like Pirates? They both murder in the high C's...`,
    "Want to hear a joke about staccato? Never mind, it's too short",
    "Did you hear the joke about fermata? Wait, it's too long",
    'What do you get when you throw a piano down a mine shaft? A-flat minor...',
    "What's the difference between a piano and a fish? You can't tune a fish!",
    'Why was the music theorist drunk? He tried to use a fifth with his tonic',
    "How do you know when an alto is standing by your door? \n They can't find their key and they don't know when to come in.."
  ];

  let random = music[Math.floor(Math.random() * music.length)];
  return (
    <div className="fourohfour">
      <div className="component_img" />
      <h1>404 Error</h1>
      <h2>Ooops! This page doesn't exist</h2>
      <h4>But here's a joke to lighten your day!</h4>
      <p>{random}</p>
    </div>
  );
};

export default Fourohfour;



// WEBPACK FOOTER //
// ./src/Components/Fourohfour/Fourohfour.js